import React, { useState } from 'react'
import '../../../../assets/css/screens/customer/dashboard/privacy&security/PrivacySecurity.css'
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import {
  ArrowLeft
} from 'lucide-react';

const ChangePasswordModal = ({ onClose }) => {
  const [showCurrent, setShowCurrent] = useState(false)
  const [showNew, setShowNew] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [form, setForm] = useState({ current: '', newPass: '', confirm: '' })

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = () => {
    if (!form.current || !form.newPass || !form.confirm) return
    if (form.newPass !== form.confirm) return
    alert('Password changed successfully!')
    onClose()
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>

        {/* <div className="modal-header">
          <button className="modal-back-btn" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <h2 className="modal-title">Change Password</h2>
        </div> */}

        <div className="modal-lock-icon">
          <div className="lock-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="#0491e1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </div>
        </div>

        <p className="modal-subtitle">Create a strong password to keep your account safe</p>

        <div className="modal-form">

          <div className="input-group">
            <label className="input-label">Current Password</label>
            <div className="input-wrap">
              <input
                type={showCurrent ? 'text' : 'password'}
                name="current"
                placeholder="Enter current password"
                value={form.current}
                onChange={handleChange}
                className="pass-input"
              />
              <button className="eye-btn" onClick={() => setShowCurrent(!showCurrent)}>
                {showCurrent ? (
                  <svg viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          <div className="input-group">
            <label className="input-label">New Password</label>
            <div className="input-wrap">
              <input
                type={showNew ? 'text' : 'password'}
                name="newPass"
                placeholder="Enter new password"
                value={form.newPass}
                onChange={handleChange}
                className="pass-input"
              />
              <button className="eye-btn" onClick={() => setShowNew(!showNew)}>
                {showNew ? (
                  <svg viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          <div className="input-group">
            <label className="input-label">Confirm New Password</label>
            <div className="input-wrap">
              <input
                type={showConfirm ? 'text' : 'password'}
                name="confirm"
                placeholder="Confirm new password"
                value={form.confirm}
                onChange={handleChange}
                className="pass-input"
              />
              <button className="eye-btn" onClick={() => setShowConfirm(!showConfirm)}>
                {showConfirm ? (
                  <svg viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          {form.newPass && form.confirm && form.newPass !== form.confirm && (
            <p className="pass-error">Passwords do not match</p>
          )}

          <button className="update-btn" onClick={handleSubmit}>
            Update Password
          </button>

        </div>
      </div>
    </div>
  )
}

const PrivacySecurity = () => {
  const [twoFactor, setTwoFactor] = useState(false)
  const [profileVisible, setProfileVisible] = useState(true)
  const [activityStatus, setActivityStatus] = useState(true)
  const [showPasswordModal, setShowPasswordModal] = useState(false)

  return (
    <>
    <AppNavbar/>
   
    <div className="ps-page">
      <div className="ps-wrapper">

        {/* Header */}
        <div className="ps-header">
          <button className="ps-back-btn" onClick={() => window.history.back()}>
             <ArrowLeft size={20}/>
          </button>
          <h1 className="ps-heading">Privacy & Security</h1>
        </div>

        {/* Settings List */}
        <div className="ps-list">

          {/* Two-Factor Authentication */}
          <div className="ps-card">
            <div className="ps-icon-wrap ps-icon-blue">
              <svg viewBox="0 0 24 24" fill="none" stroke="#0491e1" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                <path d="M9 12l2 2 4-4"/>
              </svg>
            </div>
            <div className="ps-card-content">
              <span className="ps-card-title">Two-Factor Authentication</span>
              <p className="ps-card-desc">Add extra security to your account</p>
            </div>
            <div
              className={`toggle ${twoFactor ? 'toggle-on' : ''}`}
              onClick={() => setTwoFactor(!twoFactor)}
            >
              <div className="toggle-thumb"></div>
            </div>
          </div>

          {/* Profile Visibility */}
          <div className="ps-card">
            <div className="ps-icon-wrap ps-icon-blue">
              <svg viewBox="0 0 24 24" fill="none" stroke="#0491e1" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
            </div>
            <div className="ps-card-content">
              <span className="ps-card-title">Profile Visibility</span>
              <p className="ps-card-desc">Allow others to see your profile</p>
            </div>
            <div
              className={`toggle ${profileVisible ? 'toggle-on' : ''}`}
              onClick={() => setProfileVisible(!profileVisible)}
            >
              <div className="toggle-thumb"></div>
            </div>
          </div>

          {/* Activity Status */}
          <div className="ps-card">
            <div className="ps-icon-wrap ps-icon-blue">
              <svg viewBox="0 0 24 24" fill="none" stroke="#0491e1" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
            </div>
            <div className="ps-card-content">
              <span className="ps-card-title">Activity Status</span>
              <p className="ps-card-desc">Show when you're online</p>
            </div>
            <div
              className={`toggle ${activityStatus ? 'toggle-on' : ''}`}
              onClick={() => setActivityStatus(!activityStatus)}
            >
              <div className="toggle-thumb"></div>
            </div>
          </div>

          {/* Change Password */}
          <div className="ps-card ps-card-clickable" onClick={() => setShowPasswordModal(true)}>
            <div className="ps-icon-wrap ps-icon-blue">
              <svg viewBox="0 0 24 24" fill="none" stroke="#0491e1" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
            <div className="ps-card-content">
              <span className="ps-card-title">Change Password</span>
              <p className="ps-card-desc">Update your account password</p>
            </div>
            <div className="ps-arrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </div>
          </div>

        </div>
      </div>

      {/* Change Password Modal */}
      {showPasswordModal && (
        <ChangePasswordModal onClose={() => setShowPasswordModal(false)} />
      )}
    </div>
     </>
  )
}

export default PrivacySecurity